import axios, { buildApi } from "@/libs/api.request";

export const apis = buildApi({
  get: [],
})

// 获取列表
export const getClient = params => {
  return axios.request({
    url: "/user/client",
    params,
    method: "get"
  });
};

export const getAllClient = params => {
  return axios.request({
    url: "/user/client/getList",
    method: "get",
    params
  });
};

export const searchClient = params => {
  return axios.request({
    url: "/user/client/search",
    method: "get",
    params
  });
};

// 创建列表
export const add = data => {
  return axios.request({
    url: "/user/client",
    data,
    method: "post"
  });
};
// 获取详情
export const getDetails = id => {
  return axios.request({
    url: `/user/client/${id}`,
    method: "GET"
  });
};
// 更新列表
export const update = data => {
  return axios.request({
    url: `/user/client/${data.id}`,
    method: "put",
    data
  });
};
// 更新密码
export const updatePwd = data => {
  return axios.request({
    url: `/user/client/change_password`,
    method: "put",
    data
  });
};
// 删除列表
export const del = id => {
  return axios.request({
    url: `/user/client/${id}`,
    method: "DELETE"
  });
};

// 绑定报价
export const addBindFre = data => {
  return axios.request({
    url: `/finance/clientfreight`,
    method: "post",
    data
  });
};

// 绑定报价列表
export const getBindFre = params => {
  return axios.request({
    url: `/finance/clientfreight/clientlist/${params.clientId}`,
    method: "get",
    params
  });
};

// 解绑报价
export const delBindFre = data => {
  return axios.request({
    url: `/finance/clientfreight/batchRemove`,
    method: "post",
    data
  });
};

// 所有公司
export const getCompanies = (params) => {
  return axios.request({
    url: `/common/department/companies`,
    method: "get",
    params
  });
};

export const auditClient = data => {
  return axios.request({
    url: `/user/client/audit/${data.id}`,
    method: "post",
    data
  });
};

// 获取订单类型
export const getOrderType = () => {
  return axios.request({
    url: `/finance/getOrderAllTypes`,
    method: "get"
  });
};

// 获取渠道管理的列表
export const getTransportMode = params => {
  return axios.request({
    url: `/tracker/channel`,
    method: "get",
    params
  });
};

// 获取卖家平台
export const getPlatform = params => {
  return axios.request({
    url: `/common/config/platform`,
    method: "get",
    params
  });
};

// 获取发货方式
export const getDeliverType = params => {
  return axios.request({
    url: `/common/deliverType`,
    method: "get",
    params
  });
};

export const getLog = params => {
  return axios.request({
    url: `/user/client/getlog/${params.id}`,
    method: "get",
    params
  });
};

export const getLog2 = params => {
  return axios.request({
    url: `/user/client/getlog/${params.id}?style=Payload`,
    method: "get",
    params
  });
};

export const unOperation = data => {
  return axios.request({
    url: `/finance/clientfreight/auditCancel`,
    method: "post",
    data
  });
};

export const getBindFreight = params => {
  return axios.request({
    url: `/finance/freight/listBy`,
    method: "get",
    params
  });
};

export const saveBatchStatus = data => {
  return axios.request({
    url: `/user/client/setStatus`,
    method: "post",
    data
  });
};

export const getClientConfig = params => {
  return axios.request({
    url: `/user/client/config`,
    method: "get",
    params
  });
};

export const getBindUser = params => {
  return axios.request({
    url: `/user/client/binduser`,
    method: "get",
    params
  });
};

export const setBindUser = data => {
  return axios.request({
    url: `/user/client/setUser`,
    method: "post",
    data
  });
};

export const showFinance = data => {
  return axios.request({
    url: `/user/client/showFinance/` + data.id,
    method: "post",
    data
  });
};

export const saveUserFinanceInfo = data => {
  return axios.request({
    url: `/user/client/saveUserFinanceInfo/` + data.id,
    method: "post",
    data
  });
};

export const saveUserBindInfo = data => {
  return axios.request({
    url: `/user/client/saveUserBindInfo/` + data.id,
    method: "post",
    data
  });
};

export const filterFreight = params => {
  return axios.request({
    url: `/finance/freight/filterFreight`,
    method: "get",
    params
  });
};

export const batchBind = data => {
  return axios.request({
    url: `/finance/clientfreight/batchBind`,
    method: "post",
    data
  });
};

export const fitUserRegUrl = params => {
  return axios.request({
    url: `/user/client/fitUserRegUrl`,
    method: "get",
    params
  });
};

export const batchSetting = data => {
  return axios.request({
    url: `/user/client/batch/${data.type}`,
    method: "post",
    data
  });
};

export const getAllPackageSize = () => {
  return axios.request({
    url: `/common/config/packageSize?type=ALL`,
    method: "get",
  });
}

export const reSendValidateCode = () => {
  return axios.request({
    url: `/user/client/reSendCode`,
    method: "get",
  });
}

export const validateCodeCallback = key => {
  return axios.request({
    url: `/user/client/checkCode`,
    method: "post",
    data: {key}
  });
}
